import { VERSION } from "app/core/version";

export const environment = {
  production: 'true',
  adfsAuthority: 'https://auth.alliedpilots.org/adfs/',
  apimSubscriptionKey: '2236cbe4ab3448ec976044882a539412',
  clientId: "https://logbook.alliedpilots.org",
  
  apiUrl: "https://apagateway.alliedpilots.org/pilotflightdataservice",
  crewBasicUrl: "https://apagateway.alliedpilots.org/userprofileservice/UserService/GetUsersBasicInfo",
  crewDetailUrl: "https://apagateway.alliedpilots.org/memberinfoservice/api/Membership/LookupDetails",
  
  customAuthRequestResource: 'https://mvcapi.alliedpilots.org',
  appVersion: VERSION,
};
// NC - Pipeline Trigger 11132024